import {NgModule} from '@angular/core';
import {CommonModule} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {RouterLink} from "@angular/router";
import {GestionRagResumenComponent} from "./gestion-rag-resumen.component";
import {TarjetaResumenDatosModule} from "../tarjeta-resumen-datos/tarjeta-resumen-datos.module";

@NgModule({
  declarations: [
    GestionRagResumenComponent
  ],
  exports: [
    GestionRagResumenComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    RouterLink,
    TarjetaResumenDatosModule,
  ]
})
export class GestionRagResumenModule {
}
